module.exports = __webpack_public_path__ + "assets/img/3160607dad8f05e5c08b6241a5a6bf80.png";